import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";

// Page hero used on inner pages. Keeps consistent rhythm.
const PageHero = ({ eyebrow, title, subtitle, ctaTo = "/contact#enquiry-form", ctaLabel = "Book a free assessment" }) => {
  const isAnchor = typeof ctaTo === "string" && ctaTo.startsWith("#");
  const CtaComponent = isAnchor ? "a" : Link;
  const ctaProps = isAnchor ? { href: ctaTo } : { to: ctaTo };
  return (
    <section className="relative overflow-hidden bg-[var(--ss-teal-700)] text-[var(--ss-cream)] grain">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -left-20 w-[420px] h-[420px] rounded-full bg-[var(--ss-teal-600)]/50 blur-3xl"></div>
        <div className="absolute -bottom-40 -right-20 w-[520px] h-[520px] rounded-full bg-[var(--ss-gold)]/10 blur-3xl"></div>
      </div>
      <div className="container-px max-w-7xl mx-auto pt-20 pb-24 md:pt-28 md:pb-32 relative z-10">
        <div className="max-w-3xl">
          {eyebrow && <span className="eyebrow eyebrow-on-dark reveal">{eyebrow}</span>}
          <h1 className="font-display text-5xl md:text-7xl mt-5 reveal reveal-delay-1">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg md:text-xl text-[var(--ss-cream)]/85 max-w-2xl reveal reveal-delay-2">
              {subtitle}
            </p>
          )}
          <div className="mt-8 flex flex-col sm:flex-row gap-3 reveal reveal-delay-3">
            <CtaComponent {...ctaProps} className="btn btn-gold" data-testid="page-hero-cta">
              <i className="fa-regular fa-calendar-check"></i>
              {ctaLabel}
            </CtaComponent>
            <a href={SITE.phoneHref} className="btn btn-outline-light" data-testid="page-hero-call">
              <i className="fa-solid fa-phone"></i>
              Call {SITE.phone}
            </a>
          </div>
        </div>
      </div>
      {/* Bottom curve */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" className="w-full h-[40px] block">
          <path d="M0,40 C240,10 480,60 720,30 C960,0 1200,50 1440,20 L1440,60 L0,60 Z" fill="var(--ss-paper)"/>
        </svg>
      </div>
    </section>
  );
};

export default PageHero;
